import { Component, computed } from '@angular/core';

import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { environment } from 'src/environments/environment';
import { appStatus } from 'src/app/+state/app/app.selectors';
import { AppState } from 'src/app/+state/applications';
import { LanguageSelectComponent } from 'src/app/shared/language-select/language-select.component';

@Component({
  selector: 'app-footer',
  imports: [LanguageSelectComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  version = environment.version;
  appStatus = toSignal(this.store.select(appStatus));
  extendedVersion = computed(() => !(this.appStatus()?.authStatus));

  constructor(private store: Store<AppState>) {}
}
